import React, { useState } from 'react'

import { Map } from 'immutable'
import { Field, reduxForm } from 'redux-form/immutable'

import DefaultButton from '@lyrahealth-inc/ui-core/lib/atoms/buttons/defaultButton/DefaultButton'
import TextArea from '@lyrahealth-inc/ui-core/lib/atoms/form/textArea/TextArea'
import { SelectFieldRFF } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/formElements/SelectField'

import { paymentReversalReasons } from '../../../constants/appConstants'
import HiddenField from '../HiddenField'

const reversalOptions = [
  ...Object.keys(paymentReversalReasons).map((reason) => ({ label: reason, value: reason })),
  { label: 'Other', value: 'other' },
]

const ReversePaymentForm: React.FC<ReversePaymentFormProps> = ({
  initialValues,
  showReverseText,
  submitting,
  submitFunction,
  handleSubmit,
}) => {
  const [reversalReason, setReversalReason] = useState(initialValues?.get('description') || '')
  const [reversalReasonTextArea, setReversalReasonTextArea] = useState(
    initialValues?.get('description_text_area') || '',
  )

  return (
    // @ts-expect-error TS(2322): Type 'void' is not assignable to type 'FormEventHa... Remove this comment to see the full error message
    <form onSubmit={handleSubmit(submitFunction)}>
      {showReverseText && (
        <div>
          <h3>
            <strong>Reverse Payment</strong>
          </h3>
          <p>Please describe the reason for reversing the payment</p>
        </div>
      )}
      <Field name='charge_id' type='hidden' component={HiddenField} />
      <Field
        name='description'
        // @ts-expect-error TS(2769): react-final-form's FieldRenderProps vs redux-form's WrappedFieldProps
        component={SelectFieldRFF}
        options={reversalOptions}
        placeholder='Select'
        onChange={(_event: React.ChangeEvent<any>, value: string) => {
          if (value !== 'other' && reversalReasonTextArea) {
            setReversalReasonTextArea('')
          }
          setReversalReason(value)
        }}
      />
      {reversalReason === 'other' && (
        <Field
          name='description_text_area'
          component={TextArea}
          onChange={(e: any) => setReversalReasonTextArea(e.target.value)}
          placeholder='Reason for reversing payment'
        />
      )}
      <DefaultButton
        id='requestreverse-submit'
        type='submit'
        isLoading={submitting}
        disabled={
          !(reversalReason && reversalReason !== 'other') && !(reversalReason === 'other' && reversalReasonTextArea)
        }
      >
        {showReverseText ? 'Reverse Payment' : 'Submit Comment'}
      </DefaultButton>
    </form>
  )
}

type ReversePaymentFormProps = {
  initialValues: Map<string, any>
  showReverseText: boolean
  submitting: boolean
  handleSubmit: (submitFunction: () => void) => void
  submitFunction: () => void
}

export default reduxForm({
  form: 'reversePaymentForm',
  touchOnBlur: false,
  enableReinitialize: true,
  // @ts-expect-error TS(2345): Argument of type 'FC<ReversePaymentFormProps>' is ... Remove this comment to see the full error message
})(ReversePaymentForm)
